import React, { useContext } from 'react'
import { BaseField } from 'uniforms'
import { CommunitiesContext } from '../../../hooks/CommunitiesContextProvider'
import SelectFromOptions from './SelectFromOptions'

type Props = {
  // Place form only: event and story updates do not send primaryCommunityId, so a pick on their
  // edit forms would be dropped.
  allowPickOnEdit?: boolean
}

const CommunityField: React.FC<Props> = ({ allowPickOnEdit = false }, { uniforms: { model } }) => {
  const communities = useContext(CommunitiesContext)
  // A place that lost its only community can pick one again on its edit form (CVL-80).
  const showPicker = model.isNew || (allowPickOnEdit && !model.community)

  return (
    <div className="double-input-row">
      <div className="input-col">
        {!showPicker ? (
          <>
            <label>Community</label>
            <label className="textValue">{model.community?.displayName}</label>
          </>
        ) : (
          <SelectFromOptions
            name="primaryCommunityId"
            options={communities.map(c => ({ value: c.id, label: c.displayName }))}
            placeholder="Select Community"
            value={model.primaryCommunityId}
          />
        )}
      </div>
    </div>
  )
}

CommunityField.contextTypes = BaseField.contextTypes

export default CommunityField
